import { ItemList } from '../orm'

class BpointTrolley extends ItemList {
    getEntityKey() {
        return "customer/purchased_trolley/prepare_bpoint_order"
    }

    prepareOrder({ trolley_id, total_price }) {
      return this.saveNewObject({
        trolley: trolley_id,
        total_price_in_cents: total_price,
      })
    }
    
}

export const bpointTrolley = new BpointTrolley("bpoint_trolley_default")


